module.exports = __webpack_public_path__ + "static/media/WorkL_Logo_TEAL.dd3f186b.png";